import { inject, Injectable, signal } from '@angular/core';
import { compressToUTF16, decompressFromUTF16 } from 'lz-string';

export interface Account {
    name: string;
    email: string;
    sub: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccountsService {

    private readonly ACCOUNT_PREFIX = '_acs';

    constructor() { }

    get getAccounts(): Account[] {
        const accountsFromLS = localStorage.getItem(this.ACCOUNT_PREFIX) ?? '';
        const accounts = decompressFromUTF16(accountsFromLS);
        return JSON.parse(accounts);
    }

    set setAccount(account: Account) {
        const accountsFromLS = this.getAccounts;
        if(accountsFromLS) {
            accountsFromLS.push(account);
            const accounts = compressToUTF16(JSON.stringify(accountsFromLS));
            localStorage.setItem(this.ACCOUNT_PREFIX, accounts);
            return;
        }
        const foo = [account];
        console.log('foo ', foo)
        const accounts = compressToUTF16(JSON.stringify(foo));
        localStorage.setItem(this.ACCOUNT_PREFIX, accounts);
    }
    
}
